export default "__VITE_ASSET__DOsqHM_O__"